<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <main class="main">
        <breadcrumb :list="list"/>

          <router-view></router-view>

      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader'
import Sidebar from '../components/Sidebar'
import AppFooter from '../components/AppFooter'
import Breadcrumb from '../components/Breadcrumb'
import apiService from '../services/api.service'
import router from '../router'
import config from '../config'

import { EventBus } from '../eventbus.js';

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  },
  mounted () {

  var rfqId = this.$route.params.id;
  var newUser = this.$route.query.user;
  var token = this.$route.query.token;

    // Authenticated so refresh local storage
    apiService.get('/kong/api/v1/entity/')
    .then(function (response) {
      // console.log(response.data.Result)
      // JSON.stringify(user)
      var ent = response.data.Result

      document.getElementById("myname").innerHTML = ent.name;
      localStorage.setItem('local_name', ent.name)
      localStorage.setItem('local_parent', ent['parent-id'])
      localStorage.setItem('local_id', ent['id'])
      localStorage.setItem('relationships', JSON.stringify(ent['relationships']))
      localStorage.setItem('local_company', ent['company'])

      EventBus.$emit('userUpdated', ent.name);

    })
    .catch(function (error) {
      console.log("Not Authenticated so redirect to..")

      delete localStorage['id_token'];
      delete localStorage['id_token_for'];

      if (token != null && newUser != null)
      {
        console.log("found user signup token " + token);
        router.push("/signup?rfq=" + rfqId + "&user=" + newUser + "&token=" + token)
      }

    })
  }
}

</script>



// WEBPACK FOOTER //
// User.vue?90a511ac